
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as inner from '../inner'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Response} from '../core/Response';
import {FieldModelResponse} from '../core/Response';
import {OrdersClosedSummary} from '../core/OrdersClosedSummary';
import {FieldModelOrdersClosedSummary} from '../core/OrdersClosedSummary';

/**
 * OrdersClosedSummariesGetResponse struct
 */
class OrdersClosedSummariesGetResponse extends Response {
  /**
   * Initialize struct
   * @param {!Response=} parent
   * @param {!Array=} summariesByCurrency
   * @constructor
   */
  constructor (parent = new Response(), summariesByCurrency = []) {
    super()
    super.copy(parent)
    this.SummariesByCurrency = summariesByCurrency
  }

  /**
   * Copy struct (shallow copy)
   * @this {!OrdersClosedSummariesGetResponse}
   * @param {!OrdersClosedSummariesGetResponse} other Other struct
   * @returns {!OrdersClosedSummariesGetResponse} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.SummariesByCurrency != null) {
      this.SummariesByCurrency = []
      for (let item of other.SummariesByCurrency) {
        if (item != null) {
          let tempItem
          tempItem = OrdersClosedSummary.fromObject(item)
          this.SummariesByCurrency.push(tempItem)
        } else {
          this.SummariesByCurrency.push(null)
        }
      }
    } else {
      this.SummariesByCurrency = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!OrdersClosedSummariesGetResponse}
   * @returns {!OrdersClosedSummariesGetResponse} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new OrdersClosedSummariesGetResponseModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new OrdersClosedSummariesGetResponseModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!OrdersClosedSummariesGetResponse}
   * @param {!OrdersClosedSummariesGetResponse} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof OrdersClosedSummariesGetResponse)) {
      throw new TypeError('Instance of OrdersClosedSummariesGetResponse is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!OrdersClosedSummariesGetResponse}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      SummariesByCurrency: ((this.SummariesByCurrency != null) ? Array.from(this.SummariesByCurrency, item => ((item != null) ? item : null)) : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return OrdersClosedSummariesGetResponse.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!OrdersClosedSummariesGetResponse} other Object value
   * @returns {!OrdersClosedSummariesGetResponse} Created struct
   */
  static fromObject (other) {
    return new OrdersClosedSummariesGetResponse().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!OrdersClosedSummariesGetResponse}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return OrdersClosedSummariesGetResponse.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!OrdersClosedSummariesGetResponse}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 4058
  }
}

export { OrdersClosedSummariesGetResponse };

/**
 * Fast Binary Encoding OrdersClosedSummariesGetResponse field model
 */
class FieldModelOrdersClosedSummariesGetResponse extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelResponse(buffer, 4 + 4)
    this.SummariesByCurrency = new fbe.FieldModelVector(new FieldModelOrdersClosedSummary(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4), buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
  }

  /**
   * Get the core.Response field model
   * @this {!FieldModelOrdersClosedSummariesGetResponse}
   * @returns {!FieldModelResponse} core.Response field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelOrdersClosedSummariesGetResponse}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelOrdersClosedSummariesGetResponse}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.SummariesByCurrency.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelOrdersClosedSummariesGetResponse}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.SummariesByCurrency.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelOrdersClosedSummariesGetResponse}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelOrdersClosedSummariesGetResponse.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelOrdersClosedSummariesGetResponse}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 4058
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelOrdersClosedSummariesGetResponse}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelOrdersClosedSummariesGetResponse}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.SummariesByCurrency.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SummariesByCurrency.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SummariesByCurrency.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelOrdersClosedSummariesGetResponse}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelOrdersClosedSummariesGetResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelOrdersClosedSummariesGetResponse}
   * @param {!OrdersClosedSummariesGetResponse} fbeValue Default value, defaults is new OrdersClosedSummariesGetResponse()
   * @returns {!OrdersClosedSummariesGetResponse} OrdersClosedSummariesGetResponse value
   */
  get (fbeValue = new OrdersClosedSummariesGetResponse()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelOrdersClosedSummariesGetResponse}
   * @param {!OrdersClosedSummariesGetResponse} fbeValue OrdersClosedSummariesGetResponse value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.SummariesByCurrency.fbeSize) <= fbeStructSize) {
      this.SummariesByCurrency.get(fbeValue.SummariesByCurrency)
    } else {
      fbeValue.SummariesByCurrency.length = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SummariesByCurrency.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelOrdersClosedSummariesGetResponse}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelOrdersClosedSummariesGetResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelOrdersClosedSummariesGetResponse}
   * @param {!OrdersClosedSummariesGetResponse} fbeValue OrdersClosedSummariesGetResponse value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelOrdersClosedSummariesGetResponse}
   * @param {OrdersClosedSummariesGetResponse} fbeValue OrdersClosedSummariesGetResponse value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.SummariesByCurrency.set(fbeValue.SummariesByCurrency)
  }
}

export { FieldModelOrdersClosedSummariesGetResponse };

/**
 * Fast Binary Encoding OrdersClosedSummariesGetResponse model
 */
class OrdersClosedSummariesGetResponseModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelOrdersClosedSummariesGetResponse(this.buffer, 4)
  }

  /**
   * Get the OrdersClosedSummariesGetResponse model
   * @this {!OrdersClosedSummariesGetResponseModel}
   * @returns {!FieldModelOrdersClosedSummariesGetResponse} model OrdersClosedSummariesGetResponse model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!OrdersClosedSummariesGetResponseModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!OrdersClosedSummariesGetResponseModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return OrdersClosedSummariesGetResponseModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!OrdersClosedSummariesGetResponseModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelOrdersClosedSummariesGetResponse.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!OrdersClosedSummariesGetResponseModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!OrdersClosedSummariesGetResponseModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!OrdersClosedSummariesGetResponseModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!OrdersClosedSummariesGetResponseModel}
   * @param {!OrdersClosedSummariesGetResponse} value OrdersClosedSummariesGetResponse value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!OrdersClosedSummariesGetResponseModel}
   * @param {!OrdersClosedSummariesGetResponse} value OrdersClosedSummariesGetResponse value, defaults is new OrdersClosedSummariesGetResponse()
   * @return {!object} Deserialized OrdersClosedSummariesGetResponse value and its size
   */
  deserialize (value = new OrdersClosedSummariesGetResponse()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new OrdersClosedSummariesGetResponse(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new OrdersClosedSummariesGetResponse(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!OrdersClosedSummariesGetResponseModel}
   * @param {!number} prev Previous OrdersClosedSummariesGetResponse model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { OrdersClosedSummariesGetResponseModel };
